import { baseApiAuthenticated } from '@/api/v2/index';
import { urlBuilder } from '@/api/utils';
import { BackendType } from '@/models/general';
import {
    CashDesk,
    CashDeskWithCredentials,
    convertCashDeskFromResponse,
    CreateCashDeskBody,
} from '@/models/cashDesk';

const baseUrl = urlBuilder('auth', 'cash-desks');

type GetCashDesksResponse = {
    cashDesks: CashDesk<BackendType>[];
};

export const cashDeskApi = baseApiAuthenticated
    .enhanceEndpoints({ addTagTypes: ['CASH_DESKS'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getCashDesks: builder.query<CashDesk[], void>({
                query: () => baseUrl,

                transformResponse(response: GetCashDesksResponse) {
                    return response.cashDesks.map(convertCashDeskFromResponse);
                },

                providesTags: ['CASH_DESKS'],
            }),

            postCashDesk: builder.mutation<
                CashDeskWithCredentials,
                CreateCashDeskBody
            >({
                query: (cashDesk) => ({
                    url: baseUrl,
                    method: 'POST',
                    body: cashDesk,
                }),
                invalidatesTags: ['CASH_DESKS'],
            }),

            deleteCashDesk: builder.mutation<void, CashDesk>({
                query: (cashDesk) => ({
                    url: `${baseUrl}/${cashDesk.id}`,
                    method: 'DELETE',
                }),
                invalidatesTags: ['CASH_DESKS'],
            }),
        }),
    });

export const {
    useGetCashDesksQuery,
    usePostCashDeskMutation,
    useDeleteCashDeskMutation,
} = cashDeskApi;
